import Command from '@ckeditor/ckeditor5-core/src/command';
import { Writer } from '@ckeditor/ckeditor5-core/src/editor';
import { addEmptyParagraphAfterPlugin } from '../utils';
import {
  ResourceSectionSchema,
  ResourceSectionIdAttr,
  ResourceIdsAttr,
  ResourceSectionTypeAttr,
  ResourceSectionFilterTypeAttr,
  ResourceSectionFilterRangeAttr,
} from './constants';
import { InsertResourcelistCommandOptions } from './types';

export class InsertResourceListSectionCommand extends Command {
  execute({
    resourceIds,
    resourceSectionId,
    resourceSectionType,
    resourceSectionFilterType,
    resourceSectionFilterRange,
    targetRange,
  }: InsertResourcelistCommandOptions): void {
    const { editor } = this;

    editor.model.change((writer: Writer) => {
      const resourceSection = writer.createElement(ResourceSectionSchema, {
        [ResourceIdsAttr]: resourceIds,
        [ResourceSectionIdAttr]: resourceSectionId,
        [ResourceSectionTypeAttr]: resourceSectionType,
        [ResourceSectionFilterTypeAttr]: resourceSectionFilterType,
        [ResourceSectionFilterRangeAttr]: resourceSectionFilterRange,
      });

      editor.model.insertContent(resourceSection, targetRange);

      addEmptyParagraphAfterPlugin(editor, writer, resourceSection);
    });
  }

  refresh(): void {
    const { model } = this.editor;
    const { selection } = model.document;
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      ResourceSectionSchema,
    );

    this.isEnabled = allowedIn !== null;
  }
}
